const DEFAULT_FAVICON_PATTERN =
  /(.*\/)?favicon-(\d+x\d+)\.(png|ico|gif|jpg|jpeg|svg)$/i;

const buildBadgeHref = href => {
  if (!href) {
    return null;
  }

  try {
    const url = new URL(href, window.location.origin);
    const { pathname } = url;
    const defaultMatch = pathname.match(DEFAULT_FAVICON_PATTERN);

    if (defaultMatch) {
      const [, basePath = '', size, extension] = defaultMatch;
      url.pathname = `${basePath}favicon-badge-${size}.${extension}`;
      return url.toString();
    }

    const extensionIndex = pathname.lastIndexOf('.');
    if (extensionIndex === -1) {
      return null;
    }

    const badgePath = `${pathname.slice(0, extensionIndex)}-badge${pathname.slice(
      extensionIndex
    )}`;
    url.pathname = badgePath;
    return url.toString();
  } catch (error) {
    return null;
  }
};

const rememberOriginalHref = favicon => {
  if (!favicon.dataset.originalHref) {
    favicon.dataset.originalHref = favicon.href;
  }

  if (!favicon.dataset.badgeHref) {
    const badgeHref = buildBadgeHref(favicon.dataset.originalHref);
    if (badgeHref) {
      favicon.dataset.badgeHref = badgeHref;
    }
  }
};

const canSwapIcon = favicon => Boolean(favicon.dataset.badgeHref);

const setBadgeIcon = favicon => {
  if (!canSwapIcon(favicon)) {
    return;
  }
  favicon.href = favicon.dataset.badgeHref;
};

const restoreOriginalIcon = favicon => {
  if (favicon.dataset.originalHref) {
    favicon.href = favicon.dataset.originalHref;
    return;
  }

  const fallbackBadgeHref = buildBadgeHref(favicon.href);
  if (fallbackBadgeHref) {
    favicon.dataset.badgeHref = fallbackBadgeHref;
  }
};

export const showBadgeOnFavicon = () => {
  document.querySelectorAll('.favicon').forEach(favicon => {
    rememberOriginalHref(favicon);
    setBadgeIcon(favicon);
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');
  favicons.forEach(rememberOriginalHref);

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(restoreOriginalIcon);
    }
  });
};
